import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Stack } from "@curves/ui-base";
import { BatchActionSendMessage, BatchActionDeleteGiftRecord } from './overviewListActions';
import { LabelHeaderCheckBox } from '@icoach/components';

const OverviewListBatchActions = ({ className, headerCheckBoxRef, onHeaderChange, children, ...rest }) => {
    return (
        <Stack className={'overview-list__action-group batch-actions-wrapper'} {...rest}>
            <LabelHeaderCheckBox ref={headerCheckBoxRef} onChange={onHeaderChange} />
            <Stack className={clsx('batch-actions', className)}>{children}</Stack>
        </Stack>
    );
};

OverviewListBatchActions.SendMessageAction = BatchActionSendMessage;
OverviewListBatchActions.DeleteGiftRecord = BatchActionDeleteGiftRecord;

OverviewListBatchActions.propTypes = {
    className: PropTypes.string,
    children: PropTypes.any,
};

export default OverviewListBatchActions;
